import React from 'react';

export default class ItemMensagem extends React.Component{
  render(){
    const dados = this.props.data;
    const visualizado = dados.visualizado ? '' : 'nao-visualizado';
    return(
      <div className={`${visualizado} item-listagem`} data-id={dados.id}>
        <a href='#' className='bt-mensagem' onClick={this.props.onClickHandler}>
          <div className=' bt-mensagem-data'>{dados.data}</div>
          <div>{dados.de}</div>
          <div className='bt-mensagem-assunto'>Assunto: {dados.assunto}</div>
          <div className='mensagem-text'>Mensagem: {dados.mensagem}</div>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/mensagens/ItemMensagem.js